import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import ProtectedRoute from "./ProtectedRoute";

// Layouts
import AdminLayout from "../layouts/AdminLayout";

// Pages
import LoginPage from "../pages/Login";
import UserManagementPage from "../pages/UserManagement";
import IpWhitelistPage from "../pages/IpWhitelist";
import CustomerManagementPage from "../pages/CustomerManagement";
import SettingPage from "../pages/Setting";
import TopRacePage from "../pages/TopRace";
import RewardCodePage from "../pages/RewardCode";

const AppRoutes = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    // You can render a loading spinner here
    return <div>Loading...</div>;
  }

  return (
    <Router>
      <Routes>
        <Route
          path="/login"
          element={
            !isAuthenticated ? (
              <LoginPage />
            ) : (
              <Navigate to="/customer-management" />
            )
          }
        />

        <Route
          path="/"
          element={isAuthenticated ? <AdminLayout /> : <Navigate to="/login" />}
        >
          <Route
            path="customer-management"
            element={<CustomerManagementPage />}
          />
          <Route path="reward-code" element={<RewardCodePage />} />
          <Route
            element={<ProtectedRoute allowedRoles={["admin", "superadmin"]} />}
          >
            <Route path="top-race" element={<TopRacePage />} />
            <Route path="settings" element={<SettingPage />} />
            <Route path="user-management" element={<UserManagementPage />} />
            <Route path="ip-whitelist" element={<IpWhitelistPage />} />
          </Route>
          <Route
            index
            element={<Navigate to="/customer-management" replace />}
          />
        </Route>

        {/* Add a catch-all route for 404 if needed */}
        <Route path="*" element={<Navigate replace to="/" />} />
      </Routes>
    </Router>
  );
};

export default AppRoutes;
